enum EPlatformNames {
  all= 'all',
  github = 'github',
  trello = 'trello',
  gitlab = 'gitlab',
  jira = 'jira',
  notion = 'notion',
  shopify = 'shopify'
}

export default EPlatformNames;
